import http from "./httpService";

const apiEndPoint = "/installations/";

export function getInstallationByIdentifier(identifier) {
  return http.get(`${apiEndPoint}${identifier}/`);
}

export function getBackToSalesReasons() {
  return http.get(`${apiEndPoint}back-to-sales-reasons/`);
}

export function createInstallation(data) {
  return http.post(apiEndPoint, data);
}

export function checkCrmData(params) {
  return http.get(`${apiEndPoint}crm-preview/`, { params });
}

export function updateInstallation(identifier, data) {
  return http.patch(`${apiEndPoint}${identifier}/`, data);
}

// DVR sub-resources. POST requires `dvr_login` + `dvr_password`.
export function getInstallationDvrs(identifier) {
  return http.get(`${apiEndPoint}${identifier}/dvrs/`);
}

export function createInstallationDvr(identifier, data) {
  return http.post(`${apiEndPoint}${identifier}/dvrs/`, data);
}

export function updateInstallationDvr(identifier, dvrId, data) {
  return http.patch(`${apiEndPoint}${identifier}/dvrs/${dvrId}/`, data);
}

export function deleteInstallationDvr(identifier, dvrId) {
  return http.delete(`${apiEndPoint}${identifier}/dvrs/${dvrId}/`);
}

// Idempotent: marks the selected InstallationCameras on each DVR and advances step to
// `waiting_for_veesion`. Projection to the live Store happens later, not here.
// Payload `{ dvrs: [{dvr_id, channels: [{channel_number, channel_name?}]}] }`.
// Response `{ installation, apply_result }`.
export function applyInstallationConfig(identifier, payload) {
  return http.post(`${apiEndPoint}${identifier}/apply-config/`, payload);
}

export function refreshOnboardingCode(identifier) {
  return http.post(`${apiEndPoint}${identifier}/refresh-code/`);
}

// Verify endpoints TCP-probe / DNS-resolve from the server; each call can take
// up to ~10s of synchronous work on the worker. Cap the client-side wait so the
// inline status reaches a definite end state even if the proxy chain stalls.
const VERIFY_TIMEOUT_MS = 15000;

export function verifyPortForwarding(identifier) {
  return http.get(`${apiEndPoint}${identifier}/verify/port-forwarding/`, { timeout: VERIFY_TIMEOUT_MS });
}

export function verifyDDNS(identifier) {
  return http.get(`${apiEndPoint}${identifier}/verify/ddns/`, { timeout: VERIFY_TIMEOUT_MS });
}

// Registers a No-IP subdomain server-side; the external calls run longer than a verify.
const GENERATE_TIMEOUT_MS = 30000;

export function generateDDNS(identifier) {
  return http.post(`${apiEndPoint}${identifier}/generate/ddns/`, null, { timeout: GENERATE_TIMEOUT_MS });
}

export function getInstallationSettings() {
  return http.get("/installation-settings/");
}

export function updateInstallationSettings(data) {
  return http.patch("/installation-settings/", data);
}

export function getInstallationsPaginatedEndpoint({ page, search, step, ordering }) {
  const params = new URLSearchParams({ page, ordering });
  if (search) {
    params.set("search", search);
  }
  if (step) {
    params.set("step", step);
  }
  return `${apiEndPoint}?${params}`;
}
